// extracted by mini-css-extract-plugin
export var backdropBlur = "_m9-0";
export var contentCard = "_m9-5";
export var frame = "_m9-2";
export var image = "_m9-4";
export var imagePane = "_m9-3";
export var modal = "_m9-1";